/**
 * Enum Sheet combo
 * nnninh 10/05/2023
 */
export default {
  Sheet1: 1,
  Sheet2: 2,
  Sheet3: 3,
  Sheet4: 4,
  Sheet5: 5,
  Sheet6: 6,
};
